import React from 'react';
import Notification  from 'react-web-notification';
import sound from '../../images/sound.mp3';

class SoundNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ignore: true,
            title: ''
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handlePermissionGranted(){
        this.setState({
            ignore: false
        });
    }
    handlePermissionDenied(){
        this.setState({
            ignore: true
        });
    }
    handleNotSupported(){
        this.setState({
            ignore: true
        });
    }


    handleNotificationOnShow(e, tag){
        this.playSound();
    }

    handleNotificationOnClick(e, tag){
        this.props.resetHasNotification();
    }

    handleNotificationOnError(e, tag){
    }

    playSound(filename){
        this.soundFile.play();
        this.props.resetHasNotification();
    }

    handleButtonClick() {
        if(this.state.ignore) {
            return;
        }
        const title = 'Hi!';
        const body = 'You got a new message from Kerenor Booking.';
        const options = {
            body: body,
            lang: 'en',
            dir: 'ltr',
            sound: '../../images/sound.mp3'
        };
        this.setState({
            title: title,
            options: options
        });
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.hasNotification && nextProps.hasNotification) {
            this.handleButtonClick();
        }
    }
    render() {
        return (
            <div>
                <Notification
                    ignore={this.state.ignore && this.state.title !== ''}
                    notSupported={this.handleNotSupported.bind(this)}
                    onPermissionGranted={this.handlePermissionGranted.bind(this)}
                    onPermissionDenied={this.handlePermissionDenied.bind(this)}
                    onShow={this.handleNotificationOnShow.bind(this)}
                    onClick={this.handleNotificationOnClick.bind(this)}
                    onError={this.handleNotificationOnError.bind(this)}
                    timeout={5000}
                    onClose={this.props.resetHasNotification}
                    title={this.state.title}
                    options={this.state.options}
                />
                <audio className="d-none" ref={el => {this.soundFile = el}}>
                    <source src={sound} type='audio/mpeg' />
                </audio>
            </div>
        )
    }
}


export default SoundNotification;



// WEBPACK FOOTER //
// ./src/components/NotificationSound/index.js